import React from 'react'

class EmptyWidgetMsg extends React.Component {
  render() {
    return null
  }
}

export default EmptyWidgetMsg
